<template>
  <div class="player">
    <button class="play" data-playing="false" role="switch" aria-checked="false"></button>
    <div class="trackName t-sans">{{ trackTitle }} &nbsp; | &nbsp; {{ trackAuthor }}</div>
    <div id="visualiser" class="visualiser"><canvas id="canvas" style="width: 100%; height: 100%;"></canvas></div>
    <audio :src='trackUrl' type="audio/mpeg"></audio>
    <!--<div class="close cross"></div>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AudioContext } from '../../node_modules/standardized-audio-context'

let audioElement = null

export default {
  name: 'Player',
  computed: {
    ...mapGetters(['getPlayer']),
    trackTitle () {
      return this.getPlayer.title
    },
    trackUrl () {
      return this.getPlayer.trackUrl
    },
    trackAuthor () {
      return this.getPlayer.author
    }
  },
  mounted: function () {
    var audioCtx = new AudioContext()
    audioElement = document.querySelector('audio')
    var track = audioCtx.createMediaElementSource(audioElement)
    var analyser = audioCtx.createAnalyser()
    track.connect(audioCtx.destination)
    track.connect(analyser)
    var bufferLength = analyser.frequencyBinCount
    var frequencyData = new Uint8Array(analyser.frequencyBinCount)
    analyser.getByteFrequencyData(frequencyData)
    var canvas = document.getElementById('canvas')
    var parent = document.getElementById('visualiser')
    var canvasCtx = canvas.getContext('2d')

    let WIDTH = parent.offsetWidth
    let HEIGHT = 15

    canvas.width = WIDTH
    canvas.height = HEIGHT
    canvasCtx.width = WIDTH
    canvasCtx.height = HEIGHT

    function renderFrame () {
      requestAnimationFrame(renderFrame)

      analyser.getByteFrequencyData(frequencyData)

      canvasCtx.fillStyle = '#fff'
      canvasCtx.fillRect(0, 0, WIDTH, HEIGHT)
      var barWidth = (WIDTH / bufferLength) * 2.5
      var barHeight
      var x = 0
      for (var i = 0; i < bufferLength; i++) {
        barHeight = frequencyData[i] / 3

        canvasCtx.fillStyle = 'rgb(' + (125 - barHeight) + ',' + (125 - barHeight) + ',' + (125 - barHeight) + ')'
        canvasCtx.fillRect(x, HEIGHT - barHeight / 2, barWidth, barHeight)
        x += barWidth
      }
    };
    renderFrame()
    const playButton = document.querySelector('button')
    playButton.addEventListener('click', function () {
      if (audioCtx.state === 'suspended') {
        audioCtx.resume()
      }
      if (this.dataset.playing === 'false') {
        audioElement.play()
        this.dataset.playing = 'true'
        console.log(this.dataset.playing)
      } else if (this.dataset.playing === 'true') {
        audioElement.pause()
        this.dataset.playing = 'false'
        console.log(this.dataset.playing)
      }
    }, false)
    audioElement.addEventListener('ended', () => {
      playButton.dataset.playing = 'false'
    }, false)
  },
  updated () {
    audioElement.play()
    const playButton = document.querySelector('button')
    playButton.dataset.playing = 'true'
  }
}
</script>

<style scoped lang='scss'>

canvas {
  display: block;
}

.player {
  width: 100%;
  background: #fff;
  color: #000;
  font-family: arial, sans-serif;
  padding: 10px 20px 10px 15px;
  display: inline-flex;
  justify-content: space-between;
}

button.play {
  border: none;
  background-color: transparent;
  min-width: 13px;
  min-height: 13px;
  background-size:cover;
  background-position: center;
  outline: none;
  &:hover {
    cursor: pointer;
  }
}

.play[data-playing="false"] {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgOTUgOTQuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOTUgOTQuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwb2x5Z29uIHBvaW50cz0iODEuOSw0Ny44IDEzLjEsNC41IDEzLjEsOTEuMSAiLz48L3N2Zz4=);
}

.play[data-playing="true"] {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgOTUgOTQuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOTUgOTQuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxyZWN0IHg9IjEzLjEiIHk9IjcuNCIgd2lkdGg9IjI1LjkiIGhlaWdodD0iODAuOCIvPjxyZWN0IHg9IjU2LjEiIHk9IjcuNCIgd2lkdGg9IjI1LjkiIGhlaWdodD0iODAuOCIvPjwvc3ZnPg==);}

.close {
  align-self: flex-end;
  margin-left: 15px;
}

.trackName {
  margin: 0px 15px;
  font-size: 0.85rem;
  white-space: nowrap;
  // text-transform: uppercase;
}

.visualiser {
  height: 15px;
  flex-grow: 2;
}

.cross {
  min-width: 13px;
  min-height: 13px;
  background-size:cover;
  background-position: center;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgOTUgOTQuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOTUgOTQuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwb2x5Z29uIHBvaW50cz0iODYuOSwxOCA3Nyw4LjEgNDcuNSwzNy41IDE4LDguMSA4LjIsMTggMzcuNiw0Ny40IDguMiw3Ni44IDE4LDg2LjcgNDcuNSw1Ny4zIDc3LDg2LjcgODYuOSw3Ni44IDU3LjQsNDcuNCAiLz48L3N2Zz4=);
}

@media all and (max-width: 600px) {
  .visualiser {
    display: none;
  }
  .player {
    justify-content: flex-start;
  }
  .trackName {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue